import useProcessDicomFiles from '~/hooks/useProcessDicomFiles';
import useViewportEnvironment from '~/hooks/useViewportEnvironment';
import MultiPatientConflictDialog from '~/components/Dialogs/MultiPatientConflictDialog';
import LocalFilesLoadButton from './LocalFilesLoadButton';
import { Box } from '@mui/material';
import LocalFolderLoadButton from './LocalFolderLoadButton';
import { enqueueSnackbar } from 'notistack';

export const MAX_FILES = 2000;

const LocalFilesExplorerTab = () => {
    const { initializeEnvironment } = useViewportEnvironment();
    const { processImportedFiles, patientConflict, resolvePatientConflict } =
        useProcessDicomFiles();

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.target.files && e.target.files[0]) {
            const files = Array.from(e.target.files);
            if (files.length > MAX_FILES) {
                enqueueSnackbar(
                    `Loading canceled: too many files selected. Limit is ${MAX_FILES}.`,
                    { variant: 'error' }
                );
                return;
            }
            const processedItems = await processImportedFiles(files);
            if (processedItems) {
                initializeEnvironment(processedItems);
            }
        }
    };
    return (
        <>
            <MultiPatientConflictDialog
                open={patientConflict.open}
                loadedPatientId={patientConflict.loadedPatientId}
                incomingPatientIds={patientConflict.incomingPatientIds}
                hasUnsavedChanges={patientConflict.hasUnsavedChanges}
                clinicalUse={patientConflict.clinicalUse}
                onAction={resolvePatientConflict}
            />
            <Box
                display="flex"
                flexDirection="column"
                gap={2}
                justifyContent="center"
            >
                <LocalFilesLoadButton onFilesChange={handleFileChange} />
                <LocalFolderLoadButton onFilesChange={handleFileChange} />
            </Box>
        </>
    );
};

export default LocalFilesExplorerTab;
